import { render, staticRenderFns } from "./basic-infos-form-dialog.vue?vue&type=template&id=05833a2f&scoped=true&lang=pug&"
import script from "./basic-infos-form-dialog.vue?vue&type=script&lang=ts&"
export * from "./basic-infos-form-dialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05833a2f",
  null
  
)

export default component.exports